import PRODUCTS from "./products.json"
import GENDERS from "./genders.json"
import PRODUCT_CATEGORIES from "./product_categories.json"
import VARIANTS from "./variants.json"
import PROPOSAL_STATUS from "./proposal_status.json"
import PRODUCT_TYPES from "./product_types.json"
// import PRODUCT_PERFUMER_HOUSES from "./product_perfumer_houses.json"
// import PRODUCT_PERFUMERS from "./product_perfumers.json"
// import PRODUCT_DISTRIBUTIONS from "./product_distributions.json"
// import PRODUCT_INGREDIENTS from "./product_ingredients.json"
import PRODUCT_TAGS from "./product_tags.json"
import CURRENCIES from "./currencies.json"
import TRANSLATIONS from "./translations.json"
import BRAND_DISTRIBUTIONS from "./brand_distributions.json"

export {
  PRODUCTS,
  GENDERS,
  PRODUCT_CATEGORIES,
  VARIANTS,
  PROPOSAL_STATUS,
  PRODUCT_TYPES,
  PRODUCT_TAGS,
  // PRODUCT_DISTRIBUTIONS,
  // PRODUCT_INGREDIENTS,
  // PRODUCT_PERFUMER_HOUSES,
  // PRODUCT_PERFUMERS,
  CURRENCIES,
  TRANSLATIONS,
  // Specific for Brand
  BRAND_DISTRIBUTIONS
}
